import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="inline-flex flex-col mb-[30px]">
        <h2 className="text-3xl font-bold">Privacy and Policy</h2>
        <span className="logo-bottom-line block h-px"> </span>
      </div>

      <div className="graph-dashboard bg-[#10151A] rounded-[15px] mb-[20px] p-[30px]">
        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            Agreement to Terms
          </h4>
          <p className="info-col text-justify">
            By using the HELIOS platform, you agree to the terms laid out in
            this privacy policy and consent to the collection, use, and
            management of your data as described. This policy governs all data
            interactions within the HELIOS application.
          </p>
        </div>

        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            User Representations
          </h4>
          <p className="info-col text-justify mb-2">
            Users of the HELIOS platform are responsible for providing accurate
            data and using the system in accordance with their assigned roles.
            Misuse or unauthorized access will be logged and may result in
            access restrictions.
          </p>
          <ul className="list-disc pl-5">
            <li className="text-white info-col">
              Only authorized users are allowed access to specific datasets.
            </li>
            <li className="text-white info-col">
              User activity is tracked for auditing and accountability.
            </li>
            <li className="text-white info-col">
              Users agree not to share access credentials or misuse
              organizational data.
            </li>
            <li className="text-white info-col">
              Data entry must be accurate and comply with business rules and
              validations.
            </li>
            <li className="text-white info-col">
              User roles define what data is viewable or editable within the
              application.
            </li>
          </ul>
        </div>

        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            Security of Your Information
          </h4>
          <p className="info-col text-justify">
            The HELIOS platform is built with robust security protocols to
            ensure data integrity and confidentiality. All user data and inputs
            are stored securely in an always-on relational database, and access
            is restricted through role-based permissions. Each interaction is
            logged with a timestamp and user ID to support traceability and
            accountability.
            <br />
            <br />
            Data is not shared with any third-party services or vendors. All
            processing and storage occur within the secure infrastructure of the
            HELIOS application. Validation occurs both at the frontend and
            backend to prevent erroneous or malicious data entry.
          </p>
        </div>

        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            Data Usage and Availability
          </h4>
          <p className="info-col text-justify">
            Data entered into HELIOS is used to calculate performance metrics,
            populate dashboards, and support strategic decision-making. Once all
            required fields are validated and submitted, data becomes
            immediately available for reporting.
            <br />
            <br />
            The application performs inline validations to ensure values fall
            within acceptable ranges. Invalid data may trigger warnings or be
            rejected altogether. All business logic is governed by pre-approved
            formulas and calculation rules.
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
